import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {EcorealCtSharedModule} from "../../../../shared/shared.module";
import {KeyValuePipe, NgForOf, NgIf} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {TranslateDirective} from "@ngx-translate/core";
import {CubicleOption, EditCategoryPayload, EditOptionPayload} from "../../../../shared/model/cubicleOption-model";
import {CommonModalComponent} from "../../../../shared/common-modal/common-modal.component";
import {TranslationService} from "../../../shared";
import {Range} from "../../../../shared/model/range-model";

@Component({
  selector: 'app-odm-edit-category-modal',
  imports: [
    EcorealCtSharedModule,
    KeyValuePipe,
    NgForOf,
    ReactiveFormsModule,
    TranslateDirective,
    FormsModule,
    NgIf
  ],
  templateUrl: './odm-edit-category-modal.component.html',
  styleUrl: './odm-edit-category-modal.component.scss'
})
export class OdmEditCategoryModalComponent {

  @Input()
  selectedRange: Range;

  @Input()
  selectedCategoryId: string;

  @Output()
  saveOption: EventEmitter<EditCategoryPayload> = new EventEmitter<EditCategoryPayload>();

  @ViewChild('editOptionCategoryModal', {static: false}) editOptionCategoryModal: CommonModalComponent;

  languages: string[];
  impactedReferences: string[] = [];
  editOptionCategoryForm: EditCategoryPayload = {categoryId: '', value: {}};
  option: CubicleOption;

  constructor(private readonly translationService: TranslationService) {
  }

  show(categoryName: string, categoryUsageList: string[]){
    this.translationService.getLocalesOfCountryOfKey(categoryName).subscribe((locale => {
      locale.forEach(loc => {
        this.editOptionCategoryForm.value[loc.language] = loc.translations[0].translation;
      })
    }));
    this.impactedReferences = categoryUsageList;
    this.editOptionCategoryModal.show();
  }


  hide() {
    this.editOptionCategoryModal.hide();
  }

  isValidForm(): boolean {
    for (let key in this.editOptionCategoryForm.value) {
      if(!this.editOptionCategoryForm.value[key]){
        return false;
      }
    }
    return true;
  }


  clickOnSaveOption() {
    const editPayload: EditCategoryPayload = {
      categoryId: this.selectedCategoryId,
      value: this.editOptionCategoryForm.value
    };
    this.saveOption.emit(editPayload);
  }

  // function for the ngfor + ngmodel, so it doesn't lose focus
  trackByFn(index, item): number {   return index; }

}
